/**
 * Resolve a MinIO object key to a URL the <img> tag can load.
 *
 * The backend streams image bytes at /api/images/<key> (single-origin, works on
 * localhost and behind the production domain), so this is just a relative URL —
 * no network round-trip needed.
 */
export function useImageUrl(key: string | null | undefined): string | null {
  if (!key) return null;
  // Keys are safe path segments (uuid + slashes); encode each segment.
  const encoded = key.split('/').map(encodeURIComponent).join('/');
  return `/api/images/${encoded}`;
}
